import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class HttpInterceptorInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let req = request;
    let token = sessionStorage.getItem('token') || '';
    let tokenKeycloak = sessionStorage.getItem('tokenKeycloak') || '';
    if (req.url.includes('GenerarPDF')) {
      req = req.clone({
        headers: req.headers
          .set('Content-Type', 'application/pdf')
          .set("token", token)
          .set("Authorization", `Bearer ${tokenKeycloak}`),
      });
    } else {
      req = req.clone({
        headers: req.headers
          .set('token', token)
          .append("Authorization", `Bearer ${tokenKeycloak}`) //req.headers
      });
    }
    return next.handle(req)
  }
}
